import React, { useState, useContext, useEffect } from "react";  //FB 4949
import Button from "@material-ui/core/Button";
import { Grid, Typography } from "@material-ui/core";
import InsurancePage from "../inoffice/insurance";
import { Context } from "../store";
import { modify_AppointmentDetails } from "../actions";
import useStyles from "../css/styles";
//FB-6264
import { GetAdminSettingValue, InsertPELogs } from "../api";  //FB 4949 , FB 4960
import FilterPage from "../inoffice/appointmentFilter";  //FB 4949
import { useHistory } from "react-router-dom"; //FB 4950
import globalsettings from "../../../config"; //FB 4960
import AppointmentTypePage from "../inoffice/appointmentType";//FB 7802

// update log
// FB 4371 DK    03/29/2021    Added for Patient type module in home page
// FB 4574 DK    07/15/2021    Fixed Go Back button issue
// FB 4735 DK    10/11/2021    Implementation of provider specific flow
// FB 4949 DK    02/11/2022    Enable/Disable insurance selection
// FB 4950 DK    02/14/2022    Fix for appointment filter options visibility on default location and provider flows
// FB 4960 BR    07/03/2022    Logging all actions on PE
// FB 6264 DK    11/22/2022    Migrate PE API,DB to EMR
// FB 6366 SK    02/27/2023    Disable new patients for telehealth
// FB 7801 SK    12/14/2023    PE - Handling Appointment Types that have Differing Lengths of Time
// FB 7802 SK    12/14/2023    PE - Supporting Office-Specific Custom Appointment Types
// FB 8012 SK    01/08/2024    PE - Appointment types
// FB 8142 SK    01/23/2024    Sophie - time slots are different when you go with by date vs. by provider flow
// FB 8214 SK    02/01/2024    Accept Case Sensitive Admin Setting Value for Enable PE Custom Appointments in API and Portal and PE
// FB 9973 DK    01/28/2025    Failed to fetch: GET https://drsamemr.com/api/Provider/GetSlotsByDate

export default function InofficePage(props: any) {
  const history = useHistory(); //FB 4950
  const classes = useStyles();
  const { state, dispatch } = useContext(Context);
  const [patienttype, setPatientType] = useState(
    state.appointmentdetails.patientType
  );

  // FB 4949 DK - Start
  const [isInsuranceEnabled, setIsinsuranceEnabled] = useState<boolean>(false);
  // FB 6366 SK - Start
  const [newPatient, setNewPatient] = useState<boolean>(false);
  var np;
  async function GetNewPatient() {
    var enableNewPatient = await GetAdminSettingValue(
      "Disable_New_PatientsforTelehealth"
    );
    if (state.appointmentdetails.appointmenttype == "telederm") {
      if (enableNewPatient == "true" || enableNewPatient === "True") {
        setNewPatient(true);
      }
    } else {
      setNewPatient(false);
    }
  }
  // FB 6366 SK - End
  async function GetInsuranceAvailability() {
    //FB 6264
    let isInsuranceEnabled = await GetAdminSettingValue("Enable_PE_Insurance_Selection");
    if (isInsuranceEnabled === 1) {
      setIsinsuranceEnabled(true);
    }
  }

  useEffect(() => {
    GetInsuranceAvailability();
    GetNewPatient();	// FB 6366 SK	
  }, []);
  // FB 4949 DK - End

  // FB 4950 Start
  const handleProceed = () => {
    if (state.defaultlocation.id > 0) {
      //FB 4960 Start
      InsertPELogs(globalsettings.clientIp, "Clicked on Show Schedule - by office location");
      //FB 4960 End
      history.push("/slots_bylocation", state);
    }
    else if (state.defaultprovider.id > 0) {
      //FB 4960 Start
      InsertPELogs(globalsettings.clientIp, "Clicked on Show Schedule - by provider");
      //FB 4960 End
      history.push("/slots_byprovider", state);
    }
  };
  // FB 4950 End

  //FB 4371 DK    Added to modify the state when patient type is selected
  const handleClick = (type: string) => {
    setPatientType(type);
    //FB 4960 Start
    if (type == "new") {
      InsertPELogs(globalsettings.clientIp, "Selected new patient");
    }
    else if (type == "existing") {
      InsertPELogs(globalsettings.clientIp, "Selected existing patient");
    }
    //FB 4960 End 
    modify_AppointmentDetails(
      {
        appointmenttype: state.appointmentdetails.appointmenttype,
        customappointmenttype: "",//FB 7801
        patientType: type,
        isInsuranceExist: "",
        insurance: {
          id: 0,
          planId: 0,
          name: "",
          planName: "",
        },
        appointmentfilter: "",
        provider: {
          id: 0,
          name: "",
        },
        location: {
          id: 0,
          name: "",
          address: "",
          region: 0,
        },
        date: new Date(),
      },
      dispatch
    );
  };

  const handleGoback = () => {
    //FB 4735 DK - Modified condition
    if (!(state.defaultlocation.id > 0 || state.defaultprovider.id > 0)) {
      props.onCallbackAppt("");
    }
    //FB 4950 Start
    else if ((state.defaultlocation.id > 0 || state.defaultprovider.id > 0) && patienttype !== "") {
      setPatientType("");
    }
    //FB 4574 DK - Added a condition to redirect to advance derm. website on default location workflow
    else {
      if (state.defaultlocation.id > 0) {
        window.location.href = "https://www.advanceddermatologypc.com/locations/"
      }
      else if (state.defaultprovider.id > 0) {
        window.location.href = "https://www.advanceddermatologypc.com/doctors/"
      }
    }
    //FB 4950 End
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Clicked on Go Back - Patient Type");
    //FB 4960 End
  };

  //FB 4950
  if ((state.defaultlocation.id > 0 || state.defaultprovider.id > 0) && !isInsuranceEnabled) {
    let ins = state.appointmentdetails.isInsuranceExist;
    state.appointmentdetails.isInsuranceExist = ins === "" ? "No" : ins;
  }

  //FB 7802 - Begin
  const [extractedText, setExtractedText] = useState(0);
  const [disableForm, setDisableForm] = useState(false);//FB 8012

  async function fetchAppointmentTypes() {
    //FB 9973
    //const apptTypes = (await GetAdminSettingValue("Enable PE Custom Appointments")).toLowerCase();//FB 8214
    //sessionStorage.setItem("Enable PE Custom Appointments",apptTypes);//FB 8142
    //FB 8214
    //FB 9973
    //if (apptTypes == "true") {
      setExtractedText(1);
    //}
    //else {
      //setExtractedText(0);
    //}
    //FB 8012 - Begin
    let adminSetting = await GetAdminSettingValue("DisableTeleHealth_PE");
    //FB 9973
    if (adminSetting == "true"){
      setDisableForm(true);
    }
    //FB 8012 - End
  }

  useEffect(() => {
    fetchAppointmentTypes();
  }, []);
  //FB 7802 - End

  //FB 4371 DK    Added to load the insurance module
  function getcomponent() {
    if (patienttype !== "") {
      //FB 4949 DK - Start
      if (isInsuranceEnabled) {
        return <InsurancePage onCallbackType={setPatientType} />;
      }
      //FB 4950 Start
      else if (!isInsuranceEnabled && state.defaultlocation.id == 0 && state.defaultprovider.id == 0) {
        let ins = state.appointmentdetails.isInsuranceExist;
        state.appointmentdetails.isInsuranceExist = ins === "" ? "No" : ins;
        //FB 7802 - Begin
        if (extractedText == 1) {
          return <AppointmentTypePage origin="PatientType" onCallback={setPatientType} />
        }
        else {
          return <FilterPage origin="PatientType" onCallback={setPatientType} />
        }
      }//FB 7802 - End
      //FB 4950 End
      //FB 4949 DK - End
    }
  }
  const scrollTo = (ref: any) => {
    if (ref /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div ref={scrollTo}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">
            Are you a new or existing patient?
          </Typography>
        </Grid>
        <Grid
          item
          xs={6}
          md={3}
          lg={2}
          style={{
            display: patienttype === "existing" ? "none" : "inline-flex",
          }}
        >
          <Button
            id="new"
            variant="outlined"
            onClick={() => handleClick("new")}
            className={
              patienttype === "new"
                ? classes.buttonActive
                : classes.buttonInactive
            }
            disabled={newPatient}   //FB 6366
          >
            New
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          md={3}
          lg={2}
          style={{
            display: patienttype === "new" ? "none" : "inline-flex",
          }}
        >
          <Button
            id="existing"
            variant="outlined"
            onClick={() => handleClick("existing")}
            className={
              patienttype === "existing"
                ? classes.buttonActive
                : classes.buttonInactive
            }
          >
            Existing
          </Button>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        className={classes.flexend_Grid}
      >
        {/* FB 4950 Start */}
        <Grid item xs={6} sm={4} md={3} lg={2}
          style={{
            display: ((state.defaultlocation.id > 0 || state.defaultprovider.id > 0) && patienttype !== "" && !isInsuranceEnabled) ? "flex" : "none",
          }}
        >
          <Button
            variant="contained"
            className={classes.navigationButton}
            onClick={handleProceed}
          >
            Show Schedule
          </Button>
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3} className={classes.flexend_Grid}
          style={{
            display: ((state.defaultlocation.id > 0 || state.defaultprovider.id > 0) && patienttype !== "" && !isInsuranceEnabled) || patienttype === "" ? "flex" : "none"
          }}
        >
          {/* FB 8012 */}
            <Button
              onClick={handleGoback}
              id="goBackPatientType"
              variant="contained"
              className={classes.navigationButton}
              style={{ display: disableForm ? "none" : "inline-block" }}
            >
              Go Back
            </Button>

        </Grid>
        {/* FB 4950 End */}
      </Grid>
      <React.Fragment>{getcomponent()}</React.Fragment>
    </div >
  );
}
